import { ThemeOptions } from '@mui/material/styles';

export const darkTheme: ThemeOptions = {
  shape: {
    drawerRadius: '0rem',
    buttonRadius: {
      large: '0',
      medium: '0',
      small: '0',
      extraSmall: '0',
    },
    buttonHeight: {
      large: '2.75rem',
      medium: '2.5rem',
      small: '2.25rem',
      extraSmall: '2rem',
    },
    cardRadius: '0',
    inputRadius: {
      medium: '0',
      small: '0',
    },
    inputHeight: {
      medium: '2.5rem',
      small: '2rem',
    },
    modalRadius: '0',
    menuRadius: '0',
    menuAnchorRadius: '0',
    tagRadius: '0.25rem',
    toastRadius: '0',
    tooltipRadius: '0.25rem',
    tooltipArrowRadius: '0',
    avatarRadius: '0',
    containerRadius: '0',
    chipRadius: '0.25rem',
    mapPinRadius: '999px',
  },
  palette: {
    mode: 'dark',
    primary: {
      main: '#3DA7E9',
      light: '#2e6587',
      dark: '#6fb8e7',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#F0F1F1',
      light: '#AAABC4',
      dark: '#696A80',
      contrastText: '#FFFFFF',
    },
    danger: {
      main: '#FF4D38',
      light: '#6b190c',
      dark: '#F13520',
      contrastText: '#FFFFFF',
    },
    text: {
      primary: '#F0F1F1',
      secondary: '#B1BABF',
      additional: '#AAABC4',
      disabled: '#576872',
    },
    background: {
      default: '#2C3842',
      paper: '#3D4A54',
      tooltip: '#353744',
      overlay: '#10111F99',
      loaderOverlay: '#171F25b3',
      input: '#2C3842',
      clickableHover: '#2C3842',
      selectedPaper: '#2E4054',
    },
    divider: '#61727E',
    stroke: {
      primary: '#61727E',
      secondary: '#768b9a',
      secondaryLight: '#61727E',
    },
    status: {
      grey: {
        text: '#F0F1F1',
        stroke: '#61727E',
        background: '#2C3842',
      },
      orange: {
        text: '#FFA033',
        stroke: '#FF8A04',
        background: '#462500',
      },
      green: {
        text: '#4FD639',
        stroke: '#39AD26',
        background: '#1C3D17',
      },
      purple: {
        text: '#B985F4',
        stroke: '#A46BEA',
        background: '#351F4D',
      },
      blue: {
        text: '#8683E5',
        stroke: '#6D69DF',
        background: '#252842',
      },
      red: {
        text: '#FF4D38',
        stroke: '#F13520',
        background: '#461008',
      },
      yellow: {
        text: '#D4BC4F',
        stroke: '#BCA339',
        background: '#453B15',
      },
    },
    tag: {
      stroke: '#388dbb',
      background: '#124e65',
    },
    common: {
      black: '#171F25',
      white: '#F0F1F1',
      orange: '#FFA033',
    },
    button: {
      primary: {
        background: '#10486A',
        hoverBackground: '#1A5C83',
        clickedBackground: '#6fb8e7',
        clickedShadow: '#2e6587',
        color: '#CCF5FF',
        border: '#67889C',
      },
      secondary: {
        background: '#3D4A54',
        hoverBackground: '#2e6587',
        clickedBackground: '#3D4A54',
        clickedShadow: '#3DA7E9',
        color: '#3DA7E9',
        border: '#768b9a',
      },
      alert: {
        background: '#F13520',
        hoverBackground: '#F13520',
        clickedBackground: '#F13520',
        clickedShadow: '#F13520',
        color: '#FFFFFF',
        border: '#6b190c',
      },
      alertSecondary: {
        background: '#6b190c',
        hoverBackground: '#461008',
        clickedBackground: '#6b190c',
        clickedShadow: '#FF4D38',
        color: '#FF4D38',
        border: '#F13520',
      },
    },
    selectButton: {
      arrowColor: {
        primary: '#3DA7E9',
        secondary: '#3DA7E9',
      },
    },
    map: {
      tileFilter: 'brightness(2) contrast(0.9)',
      tint: 'rgba(44, 56, 66, 0.4)',
    },
  },
  shadow: {
    drawer: '0px 10px 16px 0px rgba(0, 0, 0, 0.25)',
    menu: '0px 4px 28px 0px rgba(0, 0, 0, 0.40)',
    tooltip: '0px 0px 8px 0px rgba(0, 0, 0, 0.25)',
  },
};
